import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const benefits = ['Costruisci veicoli e robot da zero', 'Istruzioni illustrate passo dopo passo', 'Livelli di difficoltà: facile, intermedio e avanzato', 'Competenze STEM: ingegneria, logica e creatività', 'Nuovi progetti aggiunti regolarmente', 'Perfetto per giocare da soli o tra genitori e figli'];
const projects = [{
  img: 'https://cdn.magicpatterns.com/uploads/cBBDxnMb4mJFhDnHyQDyxY/IMG_1070.png',
  alt: 'Progetto creativo con una bottiglia e graffette',
  tone: 'bg-coral-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/85ppJUoEtmvkUbWcpaDyq7/IMG_1069.webp',
  alt: 'Ascensore di cartone con un semaforo luminoso',
  tone: 'bg-sky-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/acBuwab2CXMr2jfQVqrpi6/IMG_1068.webp',
  alt: 'Braccio robotico programmabile',
  tone: 'bg-sunshine-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/oURkoCn4YJBQPNbRdnBCWU/IMG_1067.png',
  alt: 'Distributore d’acqua di cartone',
  tone: 'bg-mint-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/wvbckmE64dGniQpkQvKqY8/IMG_1066.png',
  alt: 'Mano robotica meccanica',
  tone: 'bg-brand-light'
}];
export function ProjectsCarousel() {
  const prefersReducedMotion = useReducedMotion();
  const loopedProjects = [...projects, ...projects];
  return <section className="w-full overflow-hidden bg-white py-16 sm:py-24" data-id="element-156" data-mp="2q3ly0vvxof6e">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-157" data-mp="2q0q2fe7k62l4">
        <SectionHeading eyebrow="Cosa riceve tuo figlio" title={<>Oltre 100 progetti che funzionano davvero</>} subtitle="Ogni progetto è testato, illustrato e scritto in un linguaggio semplice che tuo figlio può seguire — da solo o insieme a te." data-id="element-158" data-mp="2c4mjih24xgny" />
      </div>

      <div className="mt-12 w-full overflow-hidden" aria-label="Una selezione di progetti MakerLab" data-id="element-159" data-mp="f9q7t0m84dbu">
        <motion.div className="flex w-max gap-3 px-1 sm:gap-5" animate={prefersReducedMotion ? undefined : {
        x: ['0%', '-50%']
      }} transition={prefersReducedMotion ? undefined : {
        duration: 34,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-160" data-mp="cu9umnrw23eb">
          {loopedProjects.map((project, index) => <div key={`${project.alt}-${index}`} aria-hidden={index >= projects.length} className={`h-36 w-24 flex-none overflow-hidden rounded-2xl border border-ink/10 shadow-sm sm:h-48 sm:w-36 ${project.tone}`} data-id="element-161" data-mp="muajsqcfvdqf" data-mpi={index}>
              <img src={project.img} alt={index < projects.length ? project.alt : ''} className="h-full w-full object-cover" data-id="element-162" data-mp="1fcxvxg9gjifd" />
            </div>)}
        </motion.div>
      </div>

      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-163" data-mp="1mtkt2wk4odfv">
        <ul className="mt-12 grid gap-x-8 gap-y-4 rounded-3xl border border-ink/10 bg-brand-light p-8 sm:grid-cols-2" data-id="element-164" data-mp="1mw76hctp9n60">
          {benefits.map((benefit, index) => <li key={benefit} className="flex items-start gap-3 text-sm font-medium text-ink" data-id="element-165" data-mp="1wu4txy3qjfxk" data-mpi={index}>
              <span className={`mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full ${['bg-brand text-white', 'bg-sky text-ink', 'bg-coral text-ink', 'bg-mint text-ink', 'bg-brand text-white', 'bg-sky text-ink'][index]}`} data-id="element-166" data-mp="25t8g5ay78bga">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="2ojpugaiab4i4" />
              </span>
              {benefit}
            </li>)}
        </ul>
      </div>
    </section>;
}